module.exports = __webpack_public_path__ + "img/step1_img.c2ac72a6.png";